import Header from "../components/Header";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { useNavigate  } from "react-router-dom";



export default function CheckMemberInfo() {
    const navigate = useNavigate();  
    const { t } = useTranslation();
    const {register, handleSubmit, formState }= useForm();
    const{errors} = formState;
    const userInfo = JSON.parse(localStorage.getItem("user")).data;
    if(userInfo.mberTy !== 'G'){
        
    }
    console.log(userInfo)
    const onSubmit =  {

        

    }

    return (
        <div>
            <Header type="black" handleBack={(e) => navigate("/Mypage") } pageTitle={t(`Message.my_salee_screen_user_info_chg`)}/>

            <div className="checkInfo">
                <div>
                    <p className="txt">{t(`Message.change_member_info_pw_re_enter`)}</p>
                </div>
                
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ul className="dfColG20">
                        <li className="idLi">
                            <p>{t(`Message.personal_sign_up_info_input_email`)}</p>
                            <input type="text" value="shimsoft" disabled/>
                        </li>
                        <li className="pwLi">
                            <p>{t(`Message.personal_sign_up_info_input_action_pwd`)}</p>
                            <input type="password" placeholder={t(`Message.change_member_info_enter_pw`)} {...register("password", { required:"필수 응답 항목입니다", minLength:{ value:8, message:"비밀번호는 8자 이상이여야 합니다." }})} />
                            {errors.password && <p role="alert" className="alertRed">{errors.password.message}</p>}
                        </li>
                    </ul>
                    <button 
                        type="submit" 
                        className="btn44 orgB cFFF mt30"
                        onClick={(e) => window.location.href="/ChangeMemberInfo"}
                    >
                        {t(`Message.common_ok`)}
                    </button>
                </form>
            </div>
            
        </div>
    );
};